import React from "react";
import { Language, Mail, Phone, Room } from "@mui/icons-material";
import { Box, Container, Divider, Typography } from "@mui/material";

// import { useScreenSize } from "../../../hooks/useScreenSize";

import styles from "./index.module.css";
import footer from "../../assets/image/app/footer.jpg";
import tnvLogo from "../../assets/image/app/tnv-logo.png";
import fdaLogo from "../../assets/image/app/FDA-logo.png";
import neuLogo from "../../assets/image/app/neu.webp";
import nctLogo from "../../assets/image/app/LogoNCT.png";
// import gmobileLogo from "../../../assets/image/app/G-mobile.png";

function AppFooter() {
  const isMobileMode = window.innerWidth <= 768;

  const logoWidth = isMobileMode ? 40 : 50;

  return (
    <Box
      className={styles.container}
      style={{ backgroundImage: `url(${footer})`, padding: "5px 10px" }}
    >
      {/* <Divider className={styles.divider} /> */}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        gap={"20px"}
        alignItems="center"
      >
        <Box
          bgcolor="#fff"
          borderRadius="50%"
          width={logoWidth}
          height={logoWidth}
        >
          <img
            className={styles.kiaiLogo}
            src={neuLogo}
            alt="kiai-logo"
            style={{ width: logoWidth, height: logoWidth }}
          />
        </Box>
        <Box
          bgcolor="#fff"
          borderRadius="50%"
          width={logoWidth}
          height={logoWidth}
        >
          <img
            className={styles.kiaiLogo}
            src={nctLogo}
            alt="kiai-logo"
            style={{ width: logoWidth, height: logoWidth }}
          />
        </Box>
        <Box
          bgcolor="#fff"
          borderRadius="50%"
          width={logoWidth}
          height={logoWidth}
        >
          <img
            className={styles.kiaiLogo}
            src={fdaLogo}
            alt="kiai-logo"
            style={{ width: logoWidth, height: logoWidth }}
          />
        </Box>
        <Typography
          variant="subtitle1"
          style={{
            textAlign: "center",
            fontSize: isMobileMode ? "0.8rem" : "1rem",
            padding: "0 10px",
          }}
        >
          <span>Phát triển bởi&nbsp;</span>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://fda.neu.edu.vn/cada/"
            style={{
              color: "#ee6064",
              textDecoration: "none",
              fontSize: isMobileMode ? "0.8rem" : "1rem",
            }}
          >
            <b>
              Trung tâm Nghiên cứu và chuyển giao công nghệ Trí tuệ nhân tạo và
              Khoa học dữ liệu (CADA), ĐHKTQD
            </b>
          </a>
        </Typography>
      </Box>
    </Box>
  );
}

export default AppFooter;
